import { render, staticRenderFns } from "./PhotoBookWizard.vue?vue&type=template&id=5dd3a334"
import script from "./PhotoBookWizard.vue?vue&type=script&lang=js"
export * from "./PhotoBookWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports